var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-width-huge"},[_c('TextSearchResult',_vm._b({},'TextSearchResult',_vm.passedProps,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }